import template from './index.html'
import Base from '@/core/base'
import getLang from '../../i18n'
import Common from '../poptip/common'
class PopDialog extends Base {
  initialize (params) {
    // 仅当popdialog使用在grid之中
    this.rowData = params.rowData
    // 支持tipText function引用
    if (typeof params.tipText === 'function') {
      this.tipText = params.tipText(this.rowData)
    } else {
      this.tipText = params.tipText
    }
    this.action = params.action || ''
    this.operText = params.operText
    this.hideOperation = params.hideOperation || false
    this.css = params.css
    this.okTitle = params.okTitle || getLang('确定')
    this.cancelTitle = params.cancelTitle || getLang('取消')
    this.data = params.data || {}
    Common.initialize.call(this, params)
  }
  methods (params) {
    this.handleClick = () => {
      this.visible(Number(!this.visible()))
    }
    this.handleOk = () => {
      params.onOk && params.onOk(this.data)
      setTimeout(() => {
        this.visible(0)
      }, 1000)
    }
    this.handleCancel = () => {
      this.visible(0)
    }
    this.clickoutside = () => {
      this.visible(0)
    }
  }
  subscribe (params) {
    Common.subscribe.call(this, params)
  }
}

export default {
  name: 'popdialog',
  init: Base.createViewModel(PopDialog),
  template
}



// WEBPACK FOOTER //
// ./src/components/popdialog/index.js